module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      James Thurber\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("James Thurber was born in Columbus, Ohio, in 1894. Famous for his humorous writings and illustrations, he was a staff member of "), _c('I', [_vm._v("The New Yorker")]), _vm._v(" for more than thirty years. He died in 1961. ")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/lBlz4j/tc-custom/9780063075771.jpg?1731055907283",
      "alt": "This image is the cover for the book Thurber Carnival"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Thurber Carnival\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“An authentic American genius . . . Mr. Thurber belongs in the great lines of American humorists that includes Mark Twain and Ring Lardner.” —"), _c('i', [_vm._v("The Philadelphia Inquirer")])]), _c('br'), _c('br'), _vm._v("James Thurber’s unique ability to convey the vagaries of life in a funny, witty, and often satirical way earned him accolades as one of the finest humorists of the twentieth century. A bestseller upon its initial publication in 1945, "), _c('i', [_vm._v("The Thurber Carnival")]), _vm._v(" captures the depth of his talent and the breadth of his wit. The stories compiled here, almost all of which first appeared in "), _c('i', [_vm._v("The New Yorker")]), _vm._v(", are from his uproarious and candid collection "), _c('i', [_vm._v("My World and Welcome to It")]), _vm._v("—including the American classic “The Secret Life of Walter Mitty’—as well as from "), _c('i', [_vm._v("The Owl in the Attic")]), _vm._v(", "), _c('i', [_vm._v("The Seal in the Bathroom")]), _vm._v(", and "), _c('i', [_vm._v("Men, Women and Dogs")]), _vm._v(". Thurber’s take on life, society, and human nature is timeless and will continue to delight readers even as they recognize a bit of themselves in his brilliant sketches."), _c('br'), _c('br'), _c('b', [_vm._v("“One of the absolutely essential books of our time.” —"), _c('i', [_vm._v("Saturday Review of Literature")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollinsPublishers\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0